import { useEffect } from "react";

const SUFFIX = "Poker Ledger";

/**
 * Set the document title for the duration this component is
 * mounted. Use it on top-level page components on the marketing
 * surface (and anywhere else worth a per-tab label).
 *
 *   useTitle("Pricing");
 *   // → "Pricing · Poker Ledger"
 *
 * Pass null to reset to the brand-only default.
 */
export function useTitle(title) {
    useEffect(() => {
        document.title = title ? `${title} · ${SUFFIX}` : SUFFIX;
        return () => {
            document.title = SUFFIX;
        };
    }, [title]);
}
